import { useState } from "react";

const projects = [
  { id: "ZS-2024-1847", type: "高端制造", name: "某新能源电池企业扩产项目", park: "A区-高端装备园", stage: "评估中", match: 92, time: "2天前", status: "评估中" },
  { id: "ZS-2024-1846", type: "生物医药", name: "某创新药企研发中心落户", park: "B区-生物医药港", stage: "洽谈中", match: 88, time: "3天前", status: "洽谈中" },
  { id: "ZS-2024-1845", type: "集成电路", name: "某芯片设计公司区域总部", park: "C区-集成电路园", stage: "签约待落地", match: 95, time: "1周前", status: "签约" },
  { id: "ZS-2024-1844", type: "人工智能", name: "某AI大模型企业算力中心", park: "D区-数字经济港", stage: "评估中", match: 86, time: "4天前", status: "评估中" },
  { id: "ZS-2024-1843", type: "新材料", name: "某碳纤维复合材料生产基地", park: "A区-新材料园", stage: "已投产", match: 90, time: "1月前", status: "已投产" },
];

const typeColors: Record<string, string> = {
  "高端制造": "bg-blue-100 text-blue-700",
  "生物医药": "bg-emerald-100 text-emerald-700",
  "集成电路": "bg-violet-100 text-violet-700",
  "人工智能": "bg-cyan-100 text-cyan-700",
  "新材料": "bg-amber-100 text-amber-700",
};

const stageColors: Record<string, string> = {
  "评估中": "text-blue-600 bg-blue-50",
  "洽谈中": "text-amber-600 bg-amber-50",
  "签约": "text-emerald-600 bg-emerald-50",
  "已投产": "text-slate-600 bg-slate-100",
};

export default function IMMonitor() {
  const [filter, setFilter] = useState("全部");
  const filters = ["全部", "招商线索", "项目评估", "落地跟踪"];
  const stageMap: Record<string, string[]> = {
    "招商线索": ["评估中"],
    "项目评估": ["洽谈中", "评估中"],
    "落地跟踪": ["签约", "已投产"],
  };
  const filtered = filter === "全部" ? projects : projects.filter(p => (stageMap[filter] || []).includes(p.status));

  return (
    <section className="py-20 px-8 bg-white">
      <div className="max-w-7xl mx-auto">
        {/* Section title */}
        <div className="flex items-end justify-between mb-10">
          <div>
            <span className="text-xs font-semibold text-indigo-600 tracking-widest uppercase mb-2 block">Lifecycle Monitor</span>
            <h2 className="text-3xl font-bold text-slate-800">招商全生命周期监控台</h2>
            <p className="text-slate-500 text-sm mt-1">从线索挖掘到项目投产，全程追踪每一个招商项目</p>
          </div>
          <div className="flex gap-1 bg-slate-100 rounded-xl p-1">
            {filters.map((f) => (
              <button
                key={f}
                onClick={() => setFilter(f)}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${
                  filter === f ? "bg-white text-blue-700 shadow-sm font-semibold" : "text-slate-500 hover:text-slate-700"
                }`}
              >
                {f}
              </button>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-3 gap-6">
          {/* Left column: Stats + Distribution */}
          <div className="flex flex-col gap-4">
            {/* Stats cards */}
            <div className="bg-gradient-to-br from-[#0a1e3a] to-[#0d2a4a] rounded-2xl p-5 text-white">
              <div className="flex items-center gap-2 mb-4">
                <i className="ri-pulse-line text-blue-300 text-sm"></i>
                <span className="text-white/80 text-xs font-medium">今日招商项目总览</span>
              </div>
              <div className="grid grid-cols-2 gap-3">
                {[
                  { label: "新增线索", value: "31", color: "text-blue-300" },
                  { label: "评估通过", value: "28", color: "text-emerald-300" },
                  { label: "本月签约", value: "12", color: "text-amber-300" },
                  { label: "待落地", value: "7", color: "text-rose-300" },
                ].map((s) => (
                  <div key={s.label} className="bg-white/10 rounded-xl p-3">
                    <div className={`text-xl font-bold ${s.color}`}>{s.value}</div>
                    <div className="text-white/50 text-xs mt-0.5">{s.label}</div>
                  </div>
                ))}
              </div>
            </div>

            {/* Project type distribution */}
            <div className="bg-slate-50 rounded-2xl p-5 border border-slate-100">
              <h4 className="text-slate-700 font-semibold text-sm mb-3">招商项目类型分布</h4>
              {[
                { type: "高端制造", pct: 32, color: "bg-blue-400" },
                { type: "生物医药", pct: 26, color: "bg-emerald-400" },
                { type: "集成电路", pct: 21, color: "bg-violet-400" },
                { type: "人工智能", pct: 13, color: "bg-cyan-400" },
                { type: "新材料", pct: 8, color: "bg-amber-400" },
              ].map((item) => (
                <div key={item.type} className="flex items-center gap-2 mb-2.5">
                  <span className="text-slate-600 text-xs w-20 flex-shrink-0">{item.type}</span>
                  <div className="flex-1 bg-slate-200 rounded-full h-2">
                    <div className={`${item.color} rounded-full h-2`} style={{ width: `${item.pct}%` }}></div>
                  </div>
                  <span className="text-slate-500 text-xs w-8 text-right">{item.pct}%</span>
                </div>
              ))}

              {/* Lifecycle flow */}
              <div className="mt-4 pt-4 border-t border-slate-200">
                <div className="text-xs text-slate-500 mb-2">招商全生命周期流程</div>
                <div className="flex items-center gap-1">
                  {["线索", "洽谈", "签约", "落地", "投产"].map((step, i) => (
                    <div key={step} className="flex items-center flex-1">
                      <div className="flex-1 text-center">
                        <div className="w-6 h-6 rounded-full bg-indigo-100 text-indigo-600 flex items-center justify-center mx-auto mb-1 text-xs font-bold">{i + 1}</div>
                        <div className="text-slate-500 text-xs">{step}</div>
                      </div>
                      {i < 4 && <div className="text-slate-300 text-xs flex-shrink-0 -ml-1">›</div>}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* Right: Project list */}
          <div className="col-span-2 bg-slate-50 rounded-2xl border border-slate-100 overflow-hidden flex flex-col">
            <div className="px-5 py-4 border-b border-slate-200 flex items-center justify-between">
              <span className="font-semibold text-slate-700 text-sm">项目列表</span>
              <span className="text-xs text-slate-400">{filtered.length} 条记录</span>
            </div>
            <div className="divide-y divide-slate-100 flex-1">
              {filtered.map((p) => (
                <div key={p.id} className="px-5 py-4 hover:bg-white transition-colors cursor-pointer">
                  <div className="flex items-start gap-3">
                    <span className={`text-xs border px-2 py-0.5 rounded-full flex-shrink-0 mt-0.5 ${typeColors[p.type] || "bg-slate-100 text-slate-600"}`}>
                      {p.type}
                    </span>
                    <div className="flex-1 min-w-0">
                      <div className="flex items-center gap-2 flex-wrap">
                        <span className="text-slate-800 text-sm font-medium">{p.name}</span>
                        <span className="text-xs text-slate-400 bg-slate-100 px-2 py-0.5 rounded-full">{p.park}</span>
                      </div>
                      <div className="flex items-center gap-4 mt-1.5">
                        <span className="text-xs text-slate-400"><i className="ri-loop-left-line mr-1"></i>阶段 {p.stage}</span>
                        <span className="text-xs text-slate-400"><i className="ri-brain-line mr-1"></i>匹配度 {p.match}分</span>
                        <span className="text-xs text-slate-400"><i className="ri-time-line mr-1"></i>{p.time}</span>
                        <span className="text-xs text-slate-400">{p.id}</span>
                      </div>
                    </div>
                    <span className={`text-xs font-medium flex-shrink-0 px-2.5 py-1 rounded-full ${stageColors[p.status] || "text-slate-600 bg-slate-100"}`}>{p.status}</span>
                  </div>
                </div>
              ))}
            </div>
            <div className="px-5 py-3 border-t border-slate-200 bg-white flex items-center justify-between">
              <span className="text-xs text-slate-400">数据实时更新 · 每30秒刷新</span>
              <button className="text-xs text-blue-600 hover:text-blue-700 font-medium cursor-pointer whitespace-nowrap flex items-center gap-1">
                <i className="ri-external-link-line"></i>查看全部项目
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
